<asw-payment-input-pres
  [isReadyToShow]="isReadyToShow"
  [screenEntry]="screenEntry"
  [pnrInfo]="pnrInfo"
  [isDisplayKeepMyFare]="isDisplayKeepMyFare"
  [isAncillaryService]="isAncillaryService"
  [availableBankList]="availableBankList"
  [wellnetBankList]="wellnetBankList"
  [phoneCountryInfoList]="phoneCountryInfoList"
  [isApplicableDiscountCode]="isApplicableDiscountCode"
  [isDisplayPaymentMethodSelection]="isDisplayPaymentMethodSelection"
  [appliedDiscountType]="appliedDiscountType"
  [paymentMethod]="paymentMethod"
  [currentOfficeInfo]="currentOfficeInfo"
  [totalUseCoin]="totalUseCoin"
  [isChangePaymentMethod]="isChangePaymentMethod"
  [isChangeCreditCard]="isChangeCreditCard"
  [isCreditCardPayment]="isCreditCardPayment"
  [isAfterStartingFrom]="isAfterStartingFrom"
  (getAmcMemberInformation)="getAmcMemberInformation()"
  (getAvailabilityPaymentMethod)="getAvailabilityPaymentMethod()"
  (skyCoinAllocationRecaculate)="updateSkyCoinAllocation()"
  [(data)]="data"
  [parts]="parts"
  [prevScreenInfo]="prevScreenInfo"
  [isDisplayPayMethodSelectionArea]="isDisplayPayMethodSelectionArea"
  (dataChange)="dataUpdateEvent(data)"
  (displayScreenInformation)="displayScreenInformation()"
  [isReservationOnly]="screenEntry.isReservationOnly"
  [isShowShareholderCouponsArea]="screenEntry.isShowShareholderCouponsArea"
  [shareholderCoupons]="screenEntry.shareholderCoupons"
  [isWaitlisted]="screenEntry.isWaitlisted"
  [isContainedShareholdersBenefitDiscountFareByPostCollection]="
    this.pnrInfo?.air?.isContainedShareholdersBenefitDiscountFareByPostCollection ?? true
  "
  [isContainedShareholdersBenefitDiscountFare]="this.pnrInfo?.air?.isContainedShareholdersBenefitDiscountFare ?? false"
></asw-payment-input-pres>
